import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'

import * as button from '../../button'

/**
 * Empty state component.
 *
 * #### Inputs
 * - {@link AtnDsEmptyStateComponent.description|description}!
 * - {@link AtnDsEmptyStateComponent.layout|layout}?
 * - {@link AtnDsEmptyStateComponent.rawAction|action}?
 * - {@link AtnDsEmptyStateComponent.title|title}!
 * - {@link AtnDsEmptyStateComponent.type|type}!
 *
 * #### Outputs
 * - {@link AtnDsEmptyStateComponent.action|action}
 *
 * @example
 * ```html
 * <atn-ds-empty-state
 *  action="Add Criteria"
 *  description="You don't currently have any criteria for this rule. You can add criteria by clicking the button below."
 *  layout="v"
 *  title="No Criteria? Add One."
 *  type="add-row"
 *  (action)="handleChangeHandler($event)"
 * />
 * ```
 */
@ngCore.Component({
  imports: [button.Component, ngCommon.NgClass, ngCommon.NgIf],
  selector: 'atn-ds-empty-state',
  standalone: true,
  styleUrls: ['./empty-state.component.scss'],
  templateUrl: './empty-state.component.html',
})
export class AtnDsEmptyStateComponent {
  /** TODO: js doc */
  public readonly titleSg = ngCore.input.required<string>({ alias: 'title' })
  /** TODO: js doc */
  public readonly descriptionSg = ngCore.input<string | undefined>('', {
    alias: 'description',
  })
  /**
   * Represents the text displayed on the button
   */
  public readonly rawActionSg = ngCore.input<string | undefined>(undefined, {
    alias: 'action',
  })
  /** TODO: js doc */
  public readonly layoutSg = ngCore.input<
    AtnDsEmptyStateComponent.Layout | undefined
  >('v', {
    alias: 'layout',
  })
  /** TODO: js doc */
  public readonly typeSg = ngCore.input.required<AtnDsEmptyStateComponent.Type>(
    {
      alias: 'type',
    },
  )

  /** TODO: Js doc */
  public actionSg: ngCore.Signal<string> = ngCore.computed(() => {
    const rawAction = this.rawActionSg()
    if (rawAction) {
      return rawAction
    }

    switch (this.typeSg()) {
      case 'add-row':
      case 'add-default':
      case 'add-rich-text':
        return 'Add'
      default:
        return 'Refresh'
    }
  })

  /** TODO: JS doc */
  public imageSg: ngCore.Signal<string> = ngCore.computed(
    () => `url('assets/img/empty-state/${this.typeSg()}.png')`,
  )

  /** TODO: JS doc */
  @ngCore.Output()
  public readonly action: ngCore.EventEmitter<void> =
    new ngCore.EventEmitter<void>()
}

export namespace AtnDsEmptyStateComponent {
  /**
   * v - stands for vertical
   * h - stands for horizontal
   */
  export type Layout = 'v' | 'h'
  /**
   * Represents names of images to be used
   */
  export type Type =
    | 'error'
    | 'no-data'
    | 'add-row'
    | 'add-rich-text'
    | 'add-default'
}
